export default "__VITE_ASSET__UndLIO_M__"